"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _classCallCheck = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Options = void 0;

var Interactivity_1 = require("./Interactivity/Interactivity");

var Particles_1 = require("./Particles/Particles");

var BackgroundMask_1 = require("./BackgroundMask/BackgroundMask");

var Background_1 = require("./Background/Background");

var Infection_1 = require("./Infection/Infection");

var Utils_1 = require("../../Utils");

var Options =
/*#__PURE__*/
function () {
  function Options() {
    _classCallCheck(this, Options);

    this.background = new Background_1.Background();
    this.backgroundMask = new BackgroundMask_1.BackgroundMask();
    this.detectRetina = true;
    this.fpsLimit = 30;
    this.infection = new Infection_1.Infection();
    this.interactivity = new Interactivity_1.Interactivity();
    this.particles = new Particles_1.Particles();
    this.pauseOnBlur = true;
  }

  _createClass(Options, [{
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (data === undefined) {
        return;
      }

      if (data.preset !== undefined) {
        if (data.preset instanceof Array) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data.preset[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var preset = _step.value;
              this.importPreset(preset);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          this.importPreset(data.preset);
        }
      }

      var detectRetina = (_a = data.detectRetina) !== null && _a !== void 0 ? _a : data.retina_detect;

      if (detectRetina !== undefined) {
        this.detectRetina = detectRetina;
      }

      var fpsLimit = (_b = data.fpsLimit) !== null && _b !== void 0 ? _b : data.fps_limit;

      if (fpsLimit !== undefined) {
        this.fpsLimit = fpsLimit;
      }

      if (data.pauseOnBlur !== undefined) {
        this.pauseOnBlur = data.pauseOnBlur;
      }

      this.background.load(data.background);
      this.particles.load(data.particles);
      this.infection.load(data.infection);
      this.interactivity.load(data.interactivity);
      this.backgroundMask.load(data.backgroundMask);
      Utils_1.Plugins.loadOptions(this, data);
    }
  }, {
    key: "importPreset",
    value: function importPreset(preset) {
      this.load(Utils_1.Plugins.getPreset(preset));
    }
  }, {
    key: "fps_limit",
    get: function get() {
      return this.fpsLimit;
    },
    set: function set(value) {
      this.fpsLimit = value;
    }
  }, {
    key: "retina_detect",
    get: function get() {
      return this.detectRetina;
    },
    set: function set(value) {
      this.detectRetina = value;
    }
  }]);

  return Options;
}();

exports.Options = Options;